import React from 'react';
import { URL } from './Common';
import { NavLink } from "react-router-dom";
import { mdiThumbUp } from '@mdi/js';
import Icon from '@mdi/react';


const COMMENT_LIMIT = 2000;

class CommentSection extends React.Component {
  constructor(props) {
    super(props);
    this.submitComment = this.submitComment.bind(this);
  }

  componentDidMount() {
    if (this.props?.data?.media_id) {
      this.loadComments(this.props.data.media_id);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props?.data?.media_id && prevProps?.data?.media_id !== this.props?.data?.media_id) {
      this.loadComments(this.props.data.media_id);
    }
  }

  loadComments(mediaId) {
    if (!mediaId) {
      return;
    }

    fetch(`${URL}/get_comments`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: "include",
      body: JSON.stringify({
        mediaId: mediaId,
      })
    })
      .then(res => res.text())
      .then(res => {
        const comments = JSON.parse(res);
        this.setState({
          comments: comments,
        });
      })
      .catch(err => err);
  }

  submitComment() {
    const mediaId = this.props?.data?.media_id;
    if (!mediaId) {
      return;
    }

    const comment = document.getElementById(`comment-box-${this.props?.data?.media_id}`)?.value;
    if (!comment) {
      return;
    }

    if (comment.length >= COMMENT_LIMIT) {
      this.setState({ commentErr: `Comment length of ${comment.length} exceeds limit of ${COMMENT_LIMIT} characters!` })
      return;
    }

    this.setState({
      commentErr: null,
    });

    fetch(`${URL}/add_comment`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: "include",
      body: JSON.stringify({
        mediaId: mediaId,
        comment: comment,
      })
    })
      .then(res => res.text())
      .then(res => {
        const data = JSON.parse(res);
        if (data?.error) {
          this.setState({
            commentErr: data?.error,
          });
        }
        else if (data?.comment_id) {
          const newComments = this.state.comments || [];
          newComments.push(Object.assign(data, { 'username': this.props.username }));
          document.getElementById(`comment-box-${this.props?.data?.media_id}`).value = "";
          this.setState({ comments: newComments });
        }
      })
      .catch(err => err);
  }

  likeComment(commentId, liked) {
    if (!commentId) {
      return;
    }

    fetch(`${URL}/like_comment`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: "include",
      body: JSON.stringify({
        commentId: commentId,
        liked: liked,
      })
    })
      .then(res => res.text())
      .then(res => {
        const data = JSON.parse(res);
        if (data?.comment_id === 0 || data?.comment_id > 0) {
          const newComments = this.state.comments.map(x => {
            // alter the comment to either add or remove the current user's like
            if (x.comment_id === data.comment_id) {
              if (data.liked) {
                x.like_users = x.like_users.filter(u => u);
                x.like_users.push(this.props.username)
              }
              else {
                x.like_users = x.like_users.filter(u => u && u !== this.props.username)
              }
            }
            return x;
          })

          this.setState({ comments: newComments });
        }
      })
      .catch(err => err);
  }

  render() {
    if (!this.props.data) {
      return null;
    }
    const data = this.props.data;

    return (
      <div className="blog-body" style={{ flexDirection: 'column' }}>
        <div className="title comment-text">Comments</div>
        {
          this.state?.comments?.length > 0
            ? this.state.comments.map((x, i) => {
              return (
                <div className='comment' key={`comment-${data?.media_id}-${i}`}>
                  <img
                    src={`/profile/${this.props?.profileImg?.[x.username] || 'profile-0'}.png`}
                    className={`profile-pic`}
                    style={{ 'paddingRight': '10px' }}
                  />
                  <div style={{ 'width': '100%' }}>
                    <div className='header-box'>
                      <NavLink
                        className='link-text'
                        to={`/profile/${x.username}`}
                        style={{ paddingLeft: '2px' }}
                      >
                        {`${x.username}`}
                      </NavLink>
                      <div className='small-text'>
                        {`${new Date(x.comment_date).toLocaleString()}`}
                      </div>
                    </div>
                    {
                      x.comment.split('\n').map((line, j) => {
                        return (
                          <div className='comment-text' key={`comment-${data?.media_id}-${i}-${j}`}>{line}</div>
                        )
                      })
                    }
                    {
                      this.props.username && x.username !== this.props.username
                        ? <Icon
                          className={`small-icon clickable ${x.like_users.includes(this.props.username) ? 'selected' : ''}`}
                          path={mdiThumbUp}
                          onClick={() => this.likeComment(x.comment_id, !x.like_users?.includes(this.props.username))}
                        />
                        : <Icon
                          className='small-icon'
                          path={mdiThumbUp}
                        />

                    }
                    <div className='small-text'>
                      {
                        x.like_users && x.like_users.filter(x => x).length > 0
                          ?
                          (x.like_users?.includes(this.props.username)
                            ? (x.like_users?.filter(x => x && x !== this.props.username)?.length > 0
                              ? `Liked by you and ${x.like_users?.filter(x => x && x !== this.props.username)?.length} others`
                              : 'Liked by you'
                            )
                            : `Liked by ${x.like_users?.filter(x => x)?.length} users`)
                          : ''
                      }</div>
                  </div>
                </div>
              )
            })
            : this.props?.loggedIn ? <div className='comment-text'>Be the first to add a comment!</div> : <div />
        }
        {
          this.props?.loggedIn
            ? <div style={{width: '100%'}}>
              <textarea className="commentInput" id={`comment-box-${data?.media_id}`} />
              {
                this.state?.commentErr
                  ? <p>ERROR: {this.state?.commentErr}</p>
                  : <div />
              }
              <button style={{ display: 'block' }} onClick={this.submitComment}>Add Comment</button>
            </div>
            : <div className='comment-text'>Log in to your account to add comments!</div>
        }
      </div>
    );
  }
}

export default CommentSection;
